import { useState } from "react";
import { authFetch } from "../../../api";

const AddTaskModal = ({
  openOtherTasks,
  onClose,
  activeQuarter,
  activeClass,
  refreshData,
  setSnackbarOpen,
  setSnackbarMessage,
  setSnackbarSeverity,
}) => {
  const userId = localStorage.getItem("userId");

  const [form, setForm] = useState({
    title: "",
    description: "",
    tools: "",
    isCompleted: false,
    file: null,
  });

  if (!openOtherTasks) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFileChange = (e) => {
    setForm({
      ...form,
      file: e.target.files[0],
    });
  };

  const handleSubmit = async () => {
    try {
      const response = await authFetch(
        "timeline/add-student-timeline-other-task",
        {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            user_id: userId,
            class_name: activeClass,
            quarter: activeQuarter,
            topic_name: form.title,
            task_description: form.description,
            tools_required: form.tools,
            completed: form.isCompleted,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        setSnackbarMessage("Task added successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }

      if (!result.success) {
        setSnackbarMessage(result.message || "Something went wrong");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }

      const taskId = result.data.id;

      if (form.file) {
        const formData = new FormData();
        formData.append("file", form.file);

        await authFetch(
          `timeline/upload-student-timeline-other-task?platform=1&id=${taskId}`,
          {
            method: "POST",
            body: formData,
          },
        );
      }

      refreshData();
      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="fixed font-inter inset-0 z-[1300] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="w-[92%] max-w-lg bg-white rounded-2xl shadow-xl p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-lg font-semibold">Add Other Task</h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Form */}
        <div className="space-y-4">
          <input
            name="title"
            placeholder="Task Title"
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2"
          />

          <textarea
            name="description"
            placeholder="Task Description"
            rows={3}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2"
          />

          <input
            name="tools"
            placeholder="Tools Required"
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2"
          />

          {/* Completed Checkbox */}
          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              name="isCompleted"
              checked={form.isCompleted}
              onChange={handleChange}
            />
            Mark as Completed
          </label>

          {/* Conditional Upload Field */}
          {form.isCompleted && (
            <div>
              <label className="text-sm font-medium">Upload Proof</label>
              <input
                type="file"
                onChange={handleFileChange}
                accept=".jpg,.jpeg,.png,.pdf,.mp4"
                className="w-full border rounded-lg px-4 py-2 mt-1"
              />
            </div>
          )}
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-5 py-2 border text-sm rounded-lg"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="px-6 py-2 bg-[#572575] text-white text-sm rounded-lg"
          >
            Add Task
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTaskModal;
